import { toast } from 'react-toastify';

// إعدادات التوست الافتراضية
const defaultToastConfig = {
  containerId: 'main-toast-container',
  position: 'top-right',
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  rtl: true,
};

// دالة مساعدة لإظهار رسائل النجاح
export const showSuccessToast = (message, options = {}) => {
  toast.success(message, {
    ...defaultToastConfig,
    ...options,
  });
};

// دالة مساعدة لإظهار رسائل الخطأ
export const showErrorToast = (message, options = {}) => {
  toast.error(message, {
    ...defaultToastConfig,
    autoClose: 5000, // رسائل الخطأ تبقى أطول
    ...options,
  });
};

// دالة مساعدة لإظهار رسائل التحذير
export const showWarningToast = (message, options = {}) => {
  toast.warning(message, {
    ...defaultToastConfig,
    ...options,
  });
};

// دالة مساعدة لإظهار رسائل المعلومات
export const showInfoToast = (message, options = {}) => {
  toast.info(message, {
    ...defaultToastConfig,
    ...options,
  });
};

// دالة مساعدة لحذف جميع رسائل التوست
export const dismissAllToasts = () => {
  toast.dismiss();
};

// دالة مساعدة لحذف رسالة توست محددة
export const dismissToast = (toastId) => {
  toast.dismiss(toastId);
};
